import { CalculationOutput } from '@insight2profit/api-connector/services/types';
import { DiscountModelResult } from 'shared/types/calculations';
import { QuoteLine } from 'shared/types/quoteline';
import { Quote } from './types/quote';

export const calcOutputToDiscountModelResult = (output: CalculationOutput[]) => {
  const lines = output.find(x => x.name === 'DiscountModelResults')?.value as CalculationOutput[][];
  if (!lines) return [];

  return lines.reduce((accum: DiscountModelResult[], current: CalculationOutput[]) => {
    const formatted: DiscountModelResult = {
      EffectivePeerDiscount: (current?.find(field => field.name === 'EffectivePeerDiscount')?.value as number) ?? 0,
      recommendedDiscount: (current?.find(field => field.name === 'recommendedDiscount')?.value as number) ?? 0,
      minDiscount: (current?.find(field => field.name === 'minDiscount')?.value as number) ?? 0,
      maxDiscount: (current?.find(field => field.name === 'maxDiscount')?.value as number) ?? 0,
      ListPrice: (current?.find(field => field.name === 'ListPrice')?.value as number) ?? 0,
      linePrice: (current?.find(field => field.name === 'linePrice')?.value as number) ?? 0,
      lineCost: (current?.find(field => field.name === 'lineCost')?.value as number) ?? 0,
      lineMarginPercent: (current?.find(field => field.name === 'lineMarginPercent')?.value as number) ?? 0,
      lineRevenue: (current?.find(field => field.name === 'lineRevenue')?.value as number) ?? 0,
      lineExtendedCost: (current?.find(field => field.name === 'lineExtendedCost')?.value as number) ?? 0,
      lineMarginDollars: (current?.find(field => field.name === 'lineMarginDollars')?.value as number) ?? 0,
      ItemNumber: (current?.find(field => field.name === 'ItemNumber')?.value as string) ?? 0,
      Quantity: (current?.find(field => field.name === 'Quantity')?.value as number) ?? 0,
      LineNumber: (current?.find(field => field.name === 'LineNumber')?.value as number) ?? 0,
      customernumber: (current?.find(field => field.name === 'customernumber')?.value as string) ?? 0,
    };

    return [...accum, formatted];
  }, []);
};

export const getAdjustedExtPrice = (line: QuoteLine) => {
  const extPrice = parseFloat(line.product.list_price) * line.quantity;
  if (isNaN(extPrice)) return 0;

  const discount = line.calcResults?.recommendedDiscount;
  const revisedDiscount = line.revisedDiscount;

  if (typeof revisedDiscount !== 'undefined') {
    return (1 - revisedDiscount) * extPrice;
  }

  if (typeof discount !== 'undefined') {
    return (1 - discount) * extPrice;
  }

  return extPrice;
};

export const getTotalQuoteRevenue = (q: Quote): number | undefined => {
  if (!q.quoteLines) return undefined;
  return q.quoteLines.reduce((accumulator, current) => {
    const lineRevenue = getAdjustedExtPrice(current);
    return accumulator + lineRevenue;
  }, 0);
};

export const getTotalQuoteCost = (q: Quote): number | undefined => {
  return q.quoteLines.reduce((accumulator, current) => {
    return accumulator + (current.calcResults?.lineExtendedCost ?? 0);
  }, 0);
};

export const moneyFormatter = new Intl.NumberFormat('en', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
});
